module.exports = __webpack_public_path__ + "img/pro300.4eea23af.png";